import React from 'react';
// Helpers
import { ManageAddressModalProps } from 'helpers/address';
// Ui
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
import Modal from 'ui3/Modal/Modal';
// Components
import ManageAddressForm from './components/ManageAddressForm/ManageAddressForm';
import { showToast } from 'components/common/Toast/Toast';
// Styles
import styles from './ManageAddressModal.module.scss';

const ManageAddressModal: React.FC<ManageAddressModalProps> = ({
  address,
  isOpen,
  onClose,
  container,
}) => {
  const handleSuccess = () => {
    onClose();

    showToast({
      type: 'success',
      message: `You have ${address ? 'edited' : 'added a new'} address`,
    });
  };

  const title = `${address ? 'Edit' : 'Add'} address`;

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        size="large"
        className={styles.modal}
        blockScroll={false}
        container={container}
        showCloseIcon={false}
      >
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <h2 className={styles.title}>{title}</h2>

            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close"
            >
              <MillionsIcon name="close" className={styles.closeIcon} />
            </button>
          </div>

          <ManageAddressForm
            address={address}
            onClose={handleSuccess}
            onBack={onClose}
          />
        </div>
      </Modal>
    </>
  );
};

export default ManageAddressModal;
